import { ref as o, useSlots as e, onBeforeUpdate as r, useAttrs as s } from "vue";
const n = () => {
  const t = o(e());
  return r(() => {
    t.value = e();
  }), t;
}, f = () => {
  const t = o(s());
  return r(() => {
    t.value = s();
  }), t;
};
export {
  f as useAttrsRef,
  n as useSlotsRef
};
